import { JSX, createMemo } from 'solid-js';
import { t } from '@trimble/i18n';
import {
  EditingToolbar,
  type EditingToolbarItem,
} from '@trimble/ui-components/solidjs';
import { DrawingTool } from '@trimble/geospatial';

const TOOL_CONFIG: ReadonlyArray<{
  tool: DrawingTool;
  iconName: string;
  tooltipKey: string;
}> = [
  {
    // Non-"tc-" names route to Modus icons.
    tool: DrawingTool.Point,
    iconName: 'snow_particle',
    tooltipKey: 'mobileMapping.cadEditing.tools.point',
  },
  {
    tool: DrawingTool.CompoundCurve,
    iconName: 'tc-icon-line',
    tooltipKey: 'mobileMapping.cadEditing.tools.compoundCurve',
  },
  {
    tool: DrawingTool.Rectangle,
    iconName: 'polygon_drag_rectangle',
    tooltipKey: 'mobileMapping.cadEditing.tools.rectangle',
  },
  {
    tool: DrawingTool.Polygon,
    iconName: 'polygon',
    tooltipKey: 'mobileMapping.cadEditing.tools.polygon',
  },
];

export interface CadEditingToolbarProps {
  activeTool: DrawingTool | undefined;
  disabled: boolean;
  onToggleTool(tool: DrawingTool): void;
}

export function CadEditingToolbar(props: CadEditingToolbarProps): JSX.Element {
  const tools = createMemo<EditingToolbarItem<DrawingTool>[]>(() =>
    TOOL_CONFIG.map((config) => ({
      tool: config.tool,
      iconName: config.iconName,
      tooltip: t(config.tooltipKey),
    }))
  );

  return (
    <div
      class="cad-editing-toolbar"
      style="position:absolute;left:20px;top:50%;transform:translateY(-50%);z-index:5;"
      data-testid="cad-editing-toolbar"
    >
      <EditingToolbar
        tools={tools()}
        activeTool={props.activeTool}
        disabled={props.disabled}
        onToggleTool={props.onToggleTool}
      />
    </div>
  );
}
